
import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
import { Modal,Container, Row, Col, Table,Button } from "react-bootstrap";
import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; 
import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions"; 
import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; 
import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik"; 
import MasterService from "../../Services/MasterService"; import { IoIosReturnLeft } from "react-icons/io"; import Select from 'react-select';
import { IoReturnDownBack, IoReturnDownForward } from "react-icons/io5";  import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa";

export default function DistrictMandalindprogress() {
  const { showAlert, alertData,showAlertMessage, closeAlert } = useAlert(); 
  const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); 
  const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState(); const [searchText, setSearch] = useState("");
  const[maintablenb,setmaintablenb]=useState(false);
  const[abstracttabenb,setabstracttabenb]=useState(false);
  const [searchText1, setSearch1] = useState("");
  const [searchTextabs, setSearchabs] = useState("");

  const [selecteddist,setselecteddist]=useState("");
  const [selecteddistId,setselecteddistId]=useState("");
  const [selectedmandal,setselectedmandal]=useState("");
  const [selectedDistrictname,setdistrictname]=useState("");
  const [yearList,setYearList] = useState([]);
  const [monthList, setMonthList] = useState([]);const [abstractlist, setabstractlist] = useState([]);
 const [criteriaData, setCriteriaData] = useState([]); const [remarksData, setRemarksData] = useState([]);
 const [mandalSummary, setMandalSummary] = useState([]); const [selectedMandalId, setSelectedMandalId] = useState(null); const [allAcceptance, setAllAcceptance] = useState("");
const [statusCode, setStatusCode] = useState(""); const [statusId, setStatusId] = useState(null); const [mandalList, setMandalList] = useState([]); const [formikMandalId, setformikMandalId] = useState("");

  let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); let username = localStorage.getItem("username"); 
  let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid"); let roleid = localStorage.getItem("catid"); let mainroleid = localStorage.getItem("role");
  let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbid":"mandalid"); const [showDetailTable, setShowDetailTable] = useState( ["111", "117"].includes(roleid) );

  const formik = useFormik({
    initialValues: { department_id:"", district_id:"",year:"",  month: "",type:"",typo:""},
  });



    const MandalListTable  =(payload)=>{
      KpiService.getCriteriaSelectionListData(payload).then((res) => {
            if (res.data && res.data.dataList) { const list = res.data.dataList; setMandalSummary(list); }
          });
   }  

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
    let params = { userId: username }
    let payload={ "userId": username, "districtId": district.toString(), "mandalId": mandalid.toString()}
    let payload1={ "userId": username, "districtId":roleid === "115"?"0":district.toString(), "mandalId": "0",level:"Mandal" }
    if (roleid === "117" || roleid === "111") { fetchCriteriaAndRemarks(payload); }
       if (["113", "119","115"].includes(roleid)) { MandalListTable(payload1); }
    MasterService.getAllDepts(params).then((res) => { 
      if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); 
      setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
    MasterService.getindicatorAcceptanceYear().then((achievvalueres) => { if (achievvalueres.data) { 
      let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
               setYearList(achievvalueres.data); } });
    MasterService.getkpiMonths(params).then((res) => { if (res.data && res.data.SCODE === "01") { setMonthList(res.data.SDESC || []); } 
      else { setMonthList([]); } });
    MasterService.getDistricts().then((res17) => { if (res17.data) { 
      let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); }); 
      setDistrictList([
      { id: "0", value: "All" },  
      ...(res17.data || [])
    ]); } });
     if(["113","119","117","111"].includes(roleid)){setselecteddist(localStorage.getItem("districtname"),setselecteddistId(district))}
     if(["117","111"].includes(roleid)){setselectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbname":"mandalname"))}
     if(["111","113","114","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); }
     if(["113","114","111","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); formik.setFieldValue("district_id",district); }
     if(["119","117"].includes(roleid)){ formik.setFieldValue("district_id",district); } }, []);

 
  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white",wordBreak: "break-word" };

const fetchCriteriaAndRemarks = async (payload, type) => {
  try {
    const level = type === 0 ? "Mandal" : "District";

    const criteriaRes = await KpiService.getCriteriaSelectionData({
      ...payload,
      level,
    });

    const criteriaList = criteriaRes.data?.dataList || [];

    const remarksRes = await KpiService.getCriteriaSelectionRemarks({
      ...payload,
      level,
    });

    const remarksList = remarksRes.data?.dataList || [];

    const remarksMap = new Map(
      remarksList.map(item => [item.cs_indicator_id, item.remarks])
    );

    const mergedData = criteriaList.map(item => ({
      ...item,
      remarks: remarksMap.get(item.cs_indicator_id) || null,
    }));

    setCriteriaData(mergedData);
    setRemarksData(remarksList);

    if (criteriaList.length > 0) {
      setStatusCode(criteriaList[0].status_code || "");
      setStatusId(criteriaList[0].status_id || null);
    }

  } catch (error) {
    showAlertMessage("Failed to load data", "error");
  }
};

// const fetchCriteriaAndRemarks = (payload,type) => {

//   Promise.all([
//       KpiService.getCriteriaSelectionData({ ...payload, level: type===0?"Mandal":"District", }),
//     KpiService.getCriteriaSelectionRemarks({ ...payload, level:type===0?"Mandal":"District", }),
//   ]).then(([criteriaRes, remarksRes]) => {
//   const criteriaList = criteriaRes.data?.dataList || [];
// const remarksList = remarksRes.data?.dataList || [];

// // Create lookup map using a common key
// const remarksMap = new Map(
//   remarksList.map(item => [item.cs_indicator_id, item.remarks])
// );

// const mergedData = criteriaList.map(item => ({
//   ...item,
//   remarks: remarksMap.get(item.cs_indicator_id) || null,
// }));

// setCriteriaData(mergedData);
// setRemarksData(remarksList);

//        if (criteriaList.length > 0) {
//         setStatusCode(criteriaList[0].status_code || "");
//         setStatusId(criteriaList[0].status_id||null)
//       }

//     })
//     .catch(() => {
//       showAlertMessage("Failed to load data", "error");
//     });
// };






const handleMandalClick = (mandal) => {
  setSearch("");setSearch1("")
  setSelectedMandalId(mandal.mandal_id); setselectedmandal(mandal.mandal_name);
  setdistrictname(mandal.district_name);
   const payload = { userId: username, districtId:mandal.district_id, mandalId: mandal.mandal_id,finYear: formik.values.year };
    fetchCriteriaAndRemarks(payload,formik.values.type); 
    setShowDetailTable(true);
};


const MandalData=(id)=>{
  setselecteddistId(id)
  let params = { district_id: id };
      MasterService.getMandals(params).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
          setMandalList([ { id: "0", value: "All" }, ...(res.data?? []) ]);
        }
        else{setMandalList([])}
      
})}


const[Type,setType]=useState()
const PlanningData=(type,district,typo,year)=>{
  // formik.setFieldValue(type,"")
    setType(type)
  // if (type === 1) {
  //   if (!district) return;
  // }
  // if (type === 0) {
  //   if (!district || typo === null || typo === undefined || typo === "") {
  //     return;
  //   }
  // }
   if ( type === null || type === undefined || type === "" || !district || typo === null || typo === undefined || typo === "" ||!year ) {
    return; 
  }

    if(roleid==="116"){
setShowDetailTable(false)
setmaintablenb(false)
}
let payload=
{"userId":username,"districtId":district,"mandalId":"0","level":type===0?"Mandal":"District","finYear":year}
let payload1=
{"userId":username,"districtId":district,"level":"District","finYear":year}
if(roleid==="119"&&type===1){
fetchCriteriaAndRemarks(payload1,type)
setShowDetailTable(true)
setmaintablenb(false)
}else{
  if(typo===0){
    setabstracttabenb(true)
setShowDetailTable(false)
setmaintablenb(false)
    let pay={
      userId:username,districtId:district,"level":type===0?"Mandal":"District","finYear":year
    }
KpiService.mandalIndAbstractReport(pay).then((res)=>{
            if (res.data && res.data.dataList) { const list = res.data.dataList; setabstractlist(list); }

})
  }else{
   MandalListTable(payload)
setmaintablenb(true);
setShowDetailTable(false)
setabstracttabenb(false)
  }
}

}
 const filteredData =
    searchText.length > 0 && mandalSummary?.length
      ? mandalSummary.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }) );
        })
      : mandalSummary;

       const filteredData1 =
    searchText1.length > 0 && criteriaData?.length
      ? criteriaData.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()); }) );
        })
      : criteriaData;
         const filteredabstractData1 =
    setSearchabs.length > 0 && abstractlist?.length
      ? abstractlist.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchTextabs.toLowerCase()); }) );
        })
      : abstractlist;
  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>District Mandal Performance Indicators Mapping
            <span> Acceptance Progress Report  </span> </h2> </div> </Container>
     
      <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="py-2 px-4 mb-3">
                      <Row>
                           <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
                                                 <label className="mb-1 fw-bold">Level</label> 
                            
                         
                         <Select
                           className="w-100"
                           isClearable={true}
                           isSearchable={true}
                           name="type"
                           required={true}
                           getOptionValue={(option) => option.id}
                           getOptionLabel={(option) => option.value}
                           options={[ { id: 0, value: "Mandal" }, { id: 1, value: "District" } ]}
 value={ [ { id: 0, value: "Mandal" }, { id: 1, value: "District" } ].find((option) => option?.id === formik.values?.type) || null }
                          //  onChange={(option) => {
                          //    PlanningData(option?.id,formik.values.district_id,formik.values.typo)
                          //    formik.setFieldValue("type", option ? option.id : "");
                          //  }}

                          onChange={(option) => {
  const selectedType = option ? option.id : "";

  formik.setFieldValue("type", selectedType);
  let updatedTypo = formik.values.typo;
  // if (selectedType === 0) {
  //   updatedTypo = "";
  //   // formik.setFieldValue("typo", "");
  // }
  setmaintablenb(false);
  setShowDetailTable(false);
  setabstracttabenb(false);
  PlanningData(selectedType, formik.values.district_id, updatedTypo,formik.values.year);
}}
                           menuPortalTarget={document.body}
                           styles={{
                             menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                           }}
                         />
                                                </Col> 
                         {["113","119","117","111","116"].includes(roleid) && 
                         <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> 
                          <Select 
                          {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: roleid==="116"?false:true, 
                            extraOnChange: (option) => {
                              PlanningData(formik.values.type,option?.id,formik.values.typo,formik.values.year);
                              // formik.setFieldValue("typo","")
                              MandalData(option?.id||null)} })}
                        /> </Col> } 

                       
                          <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> 
                                                 <label className="mb-1 fw-bold">Type</label> 
                            
                         
                         <Select
                           className="w-100"
                           isClearable={true}
                           isSearchable={true}
                           name="typo"
                           required={true}
                           getOptionValue={(option) => option.id}
                           getOptionLabel={(option) => option.value}
                           options={[ { id: 0, value: "Abstract" }, { id: 1, value: "Detailed" } ]}
 value={ [ { id: 0, value: "Abstract" }, { id: 1, value: "Detailed" } ].find((option) => option?.id === formik.values?.typo) || null }
                           onChange={(option) => {
                             PlanningData(formik.values.type,formik.values.district_id,option?.id,formik.values.year)
                             formik.setFieldValue("typo", option ? option.id : "");
                           }}
                           menuPortalTarget={document.body}
                           styles={{
                             menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                           }}
                         />
                         </Col>
                        <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">Financial Year</label>
                    <Select
                      {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik,
                        extraOnChange: (option) => { PlanningData(formik.values.type, formik.values.district_id, formik.values.typo, option?.id) } })}
                    /> </Col>
                      </Row> </div> </Form> </FormikProvider>


 {abstracttabenb&&(
<>
   <Row>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                    
                    <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
                      
                      <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
                      <input type="text" value={searchTextabs}
                      placeholder="Search"  onChange={(e) => setSearchabs(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
                    </div>
                  </Col>
                  <Col className="mb-2">
                   <button size="sm" className="btn mx-2 excel-btn"  onClick={() => exportToExcel("my-table", "DistrictMandalPerformanceIndicatorsAbstractReport")} style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                 
                  </Col>
                </Row>
        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> 
        <span className="style">
            {Type === 0
              ? "District Mandal Indicators Performance Acceptance Abstract Report"
              : "District Indicators Performance Acceptance Abstract Report"}
          </span>
             <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>

        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">

          <Table bordered className="custom-table" id="my-table">
            <thead>
             <tr className="text-center only-export">
  <th colSpan={6} style={{ textAlign: "center" }}>
   <span className="style">
    {Type === 0
      ? "District Mandal Indicators Performance Acceptance Abstract Report"
      : "District Indicators Performance Acceptance Abstract Report"}
  </span>
  </th>
</tr>

<tr className="text-center only-export">
  <th colSpan={6}>
    <div className="style-1">
      Report On : {currentdate} {currenttime}
    </div>
  </th>
</tr>
              <tr className="text-center"> <th>Sl.No</th>  
                  {Type === 0 ? (
                    <> <th>District</th><th>Total Mandals</th><th>Mandal Draft Save</th> <th>Mandal Pending at Approver</th> 
                     <th>Mandal Approved</th> <th>Mandals not Submitted</th>
                         </>
                      ) : (
                        <> <th>Total District Count</th> <th>District Draft Save</th>
                          <th>District Pending at Approver</th> <th>District Approved</th> <th>District Not Submitted</th> </>
                      )}
               </tr>
            
            </thead>

 <tbody>
  {(() => {
    let prevDistrict = "";

    return filteredabstractData1.map((item, index) => {
      const showDistrict = item.district_name !== prevDistrict;
      prevDistrict = item.district_name;

      return (
        <tr key={index}>
          <td className="text-center">{index + 1}</td>
          {/* <td>{item.district_name}</td> */}

          {((Type === 0) &&(formik.values.district_id))&& (
            <td >
              {showDistrict ? item.district_name : ""}
            </td>
          )}


           {Type === 0 ? (
        <>
          <td className="text-end">{item.total_mandals}</td>
          <td className="text-end">{item.mandal_draft_save}</td>
          <td className="text-end">{item.mandal_pending_at_approver}</td>
          <td className="text-end">{item.mandal_approved}</td>
          <td className="text-end">{item.mandal_not_submitted}</td>
        </>
      ) : (
        <>
          <td className="text-end">{item.total_counts}</td>
          <td className="text-end">{item.district_draft_save}</td>
          <td className="text-end">{item.district_pending_at_approver}</td>
          <td className="text-end">{item.district_approved}</td>
          <td className="text-end">{item.district_not_submitted}</td>
        </>
      )}
        </tr>
      );
    });
  })()}
</tbody>
  </Table>
  </div>
  </div>
      </>  )}        
  










              {/* ================= SUMMARY TABLE (113,119) ================= */}
        
     
        {["113", "119","115","116"].includes(roleid) && !showDetailTable && maintablenb&&(
<>
   <Row>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                    
                    <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
                      
                      <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
                      <input type="text" value={searchText}
                      placeholder="Search"  onChange={(e) => setSearch(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
                    </div>
                  </Col>
                  <Col className="mb-2">
                   <button size="sm" className="btn mx-2 excel-btn"  onClick={() => exportToExcel("my-table", "DistrictMandalPerformanceIndicatorsProgressReport")} style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                 
                  </Col>
                </Row>
        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> <span className="style"> District Mandal Indicators Peformance Acceptance Report</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>

        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">

          <Table bordered className="custom-table" id="my-table">
            <thead>
             <tr className="text-center only-export">
  <th colSpan={6} style={{ textAlign: "center" }}>
    <span className="style">
      District Mandal Indicators Performance Acceptance Report
    </span>
  </th>
</tr>

<tr className="text-center only-export">
  <th colSpan={6}>
    <div className="style-1">
      Report On : {currentdate} {currenttime}
    </div>
  </th>
</tr>
              <tr className="text-center"> <th>Sl.No</th> <th>District</th>{Type===0&&<th>Mandal</th>} <th>Total Indicators</th> <th>Required</th> <th>Not Required</th> <th>Status</th> </tr>
            
            </thead>

 <tbody>
        {filteredData && filteredData.length > 0 ? (
          (() => {
            let prevDistrict = "";

            return filteredData.map((item, index) => {
              const showDistrict = item.district_name !== prevDistrict;
              prevDistrict = item.district_name;

              return (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>

                  {((Type === 0) && (formik.values.district_id)) && (
                    <td>
                      {showDistrict ? item.district_name : ""}
                    </td>
                  )}
                  <td>
                    {!(item.status_code === null ||
                       item.status_code === "NOT YET SUBMITTED") ? (
                      <button
                        type="button"
                        onClick={() => handleMandalClick(item)}
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textDecoration: "underline",
                          background: "none",
                          border: "none",
                          padding: 0,
                        }}
                      >
                        {Type === 1 ? item.district_name : item.mandal_name}
                      </button>
                    ) : (
                      Type === 1 ? item.district_name : item.mandal_name
                    )}
                  </td>

                  <td className="text-end">{item.total_indicators}</td>
                  <td className="text-end">{item.required_indicators}</td>
                  <td className="text-end">{item.remaining_indicators}</td>
                  <td className="text-center">{item.status_code}</td>
                </tr>
              );
            });
          })()
        ) : (
          <tr>
            <td colSpan={Type === 0 ? 7 : 6} className="text-center py-3">
              No data found
            </td>
          </tr>
        )}
      </tbody>
  </Table>
  </div>
  </div>
      </>  )}        
  
        {showDetailTable &&<> 
        
     <Row>
  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-3">
    <div
      style={{
        alignItems: "center",
        display: "flex",
        border: "1px solid #ddd",
        borderRadius: "20px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease-in-out",
        backgroundColor: "#fff",
        padding: "5px 10px",
        width: "150px",
        minWidth: "150px",
      }}
    >
      <AiOutlineSearch
        className="me-2"
        style={{ color: "#888", fontSize: "1.2rem" }}
      />
      <input
        type="text"
        value={searchText1}
        placeholder="Search"
        onFocus={(e) => {
          const parent = e.currentTarget.parentElement;
          parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)";
          parent.style.border = "1px solid #353935";
          parent.style.width = "100%";
        }}
        onChange={(e) => setSearch1(e.target.value)}
        onBlur={(e) => {
          const parent = e.currentTarget.parentElement;
          parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
          parent.style.border = "1px solid #ddd";
          parent.style.width = "150px";
        }}
        style={{
          flex: "1",
          border: "none",
          outline: "none",
          fontSize: "1rem",
          color: "#333",
          backgroundColor: "transparent",
        }}
      />
    </div>
  </Col>

  {/* Right side buttons */}
  <Col className="d-flex justify-content-end align-items-center gap-2">
    
  {["113", "119", "116"].includes(roleid) &&
 !(roleid === "119" && Type === 1) && (
  <Button
    variant="warning"
    size="sm"
    className="warn-btn"
    onClick={() => {
      MandalListTable({
        userId: username,
        districtId: formik.values.district_id,
        mandalId: "0",
        level: Type === 0 ? "Mandal" : "District",
        finYear: formik.values.year,
      });
      setShowDetailTable(false);
    }}
  >
    <IoIosReturnLeft style={{ fontSize: "18px", marginRight: "5px" }} />
    Back
  </Button>
)}

    <button
      className="btn excel-btn"
      onClick={() =>
        exportToExcel(
          "my-table",
          "DistrictMandalPerformanceIndicatorsProgressReport"
        )
      }
      style={{ color: "#ffffff" }}
    >
      Excel <AiFillFileExcel style={{ fontSize: "18px" }} />
    </button>

  </Col>
</Row>
        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
          <span className="style"> {Type===0? "Mandal":"District"} Performance Indicators Mapping Progress</span>
          {selectedDistrictname && ( <div style={{ fontWeight: "bold", marginTop: "5px" }}> District: {selectedDistrictname} </div> )}
        
          {selectedmandal && !(roleid === "119" && Type === 1) && ( <div style={{ fontWeight: "bold", marginTop: "5px" }}> Mandal: {selectedmandal} </div> )}
          {/* {((selectedmandal)&&(roleid!=="119"&&Type!==1)) && ( <div style={{ fontWeight: "bold", marginTop: "5px" }}> Mandal: {selectedmandal} </div> )} */}
           
           
            {statusCode && ["111", "117"].includes(roleid) && ( <div style={{ marginTop: "5px", color: "#2f4f4f", fontWeight: "500" }}> Status: {statusCode} </div>
  )}
         
        </div>

        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
            <Table bordered id="my-table" className="custom-table table table-bordered sticky-table">
         
                      <thead>
                        <tr className="text-center only-export">
  <th colSpan={6} style={{ textAlign: "center" }}>
    <span className="style">
      {Type === 0 ? "Mandal" : "District"} Performance Indicators Mapping Progress
    </span>
  </th>
</tr>


{selectedDistrictname && (
  <tr className="text-center only-export">
    <th colSpan={6}>
      <div style={{ fontWeight: "bold" }}>
        District: {selectedDistrictname}
      </div>
    </th>
  </tr>
)}
      
{selectedmandal && (
  <tr className="text-center only-export">
    <th colSpan={6}>
      <div style={{ fontWeight: "bold" }}>
        Mandal: {selectedmandal}
      </div>
    </th>
  </tr>
)}                  <tr className="text-center">
                          <th style={{headerStyle, width: "100px"}} >Sl.No.</th>
                          <th style={{headerStyle, width: "200px"}} >Indicator Type</th>
                        <th style={{ ...headerStyle, width: "200px" }} > Indicator </th>
                          <th style={{headerStyle , width: "300px" }} >Acceptance</th>

                          <th style={headerStyle} >Remarks</th>
                        </tr>

                       
                      </thead>

       
         
      <tbody>
        {filteredData1 && filteredData1.length > 0 ? (
          filteredData1.map((item, index) => (
            <tr key={index}>
              <td className="text-center">{index + 1}</td>
              <td style={{ textAlign: "left" }}>
                {item.cs_indicator_type}
              </td>
              <td
                style={{
                  textAlign: "left",
                  width: "350px",
                  maxWidth: "350px",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {item.cs_indicator_name}
              </td>
              <td className="text-center">
                {item.is_required === true
                  ? "Required"
                  : item.is_required === false
                  ? "Not Required"
                  : "-"}
              </td>
              <td>{item.remarks}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5} className="text-center py-3">
              No data found
            </td>
          </tr>
        )}
      </tbody>

        </Table>
       
        </div> </div> </>}

       </Container>
               
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
